const NAMESPACE = 'DUCKS/LIVE_CHECK';

export default NAMESPACE;
